import $ from "jquery";
import Seed from "DMS/Seed/All";
async function getGeolocParams(idToFind) {
    let value;
    $(document).find('#' + idToFind).children().each(function () {
        if ($(this).hasClass('active')) {
            value = $(this)[0].attributes[5].textContent;
        }
    });
    return {
        'propName': idToFind,
        'value': value
    };
}
async function getFiltersValues() {
    let arrayOfResult = [];
    let splittedId = [];
    Seed.Tab.GetFrame().find('.tableRecherche > .row > .col-lg-12 > .input-group, select').each(function () {
        if ($(this).hasClass('input-group')) {
            let inputElement = $(this).children('input');
            splittedId = getElementId(inputElement);
            arrayOfResult[splittedId[2]] = {
                'value': inputElement[0].value,
                'table-to-join': inputElement[0].dataset.table,
                'operator': inputElement[0].dataset.operator
            };
        }
        else if ($(this).prop('tagName').toLowerCase() === 'select') {
            handleSelectData(this, arrayOfResult);
        }
    });
    return arrayOfResult;
}
function getElementId(element) {
    return element.attr('id').split('_', 4);
    ;
}
function handleSelectData(selectElement, arrayOfResult) {
    let splittedId = getElementId($(selectElement));
    let dataTable = $(selectElement).attr('data-table');
    let operator = $(selectElement).attr('data-operator');
    let selectedOption;
    $(selectElement).children().each(function () {
        if ($(this).prop('selected')) {
            selectedOption = this;
        }
    });
    arrayOfResult[splittedId[2]] = {
        'value': selectedOption.text,
        'table-to-join': dataTable,
        'operator': operator
    };
}
export default async function getGeolocParamsAndFilters() {
    var promises = [
        await getGeolocParams('location-type'),
        await getGeolocParams('traffic'),
        await getGeolocParams('tour-mode'),
        await getFiltersValues()
    ];
    return Promise.all(promises)
        .then(results => {
        return results.reduce((prev, curr) => {
            if ('propName' in curr) {
                prev[curr.propName] = curr.value;
            }
            else {
                prev['filters'] = curr;
            }
            return prev;
        }, {});
    });
}
//# sourceMappingURL=GoogleMapFilters.js.map